export const goals = {
    // Títulos de header do Stack (app/goals/_layout.tsx).
    screens: {
        index: 'Metas e Caixinhas',
        detail: 'Meta',
        formNew: 'Nova Meta',
        formEdit: 'Editar Meta',
    },
    list: {
        emptyTitle: 'Nada por aqui ainda',
        emptySubtitle: 'Crie uma Meta para acompanhar um objetivo, ou uma Caixinha para reservar dinheiro dentro de uma conta.',
        emptyAction: 'Criar',
        archivedA11y: 'Caixinhas arquivadas',
        caixinhasTitle: 'Caixinhas',
        caixinhasSubtitle: '{{amount}} reservado nas contas',
        metasTitle: 'Metas',
        metasSubtitle: '{{amount}} acompanhado · sem mexer no saldo',
        metasSubtitleEmpty: 'Sem mexer no saldo',
        accountFallback: 'Conta',
        caixinhaRemaining: '{{account}} · faltam {{amount}}',
        caixinhaNoTarget: '{{account}} · sem meta',
        caixinhaOfTarget: 'de {{amount}}',
        caixinhaSaved: 'guardado',
        goalProgress: '{{current}} de {{target}}',
        completedBadge: 'Concluída',
    },
    detail: {
        moreOptionsAccessibility: 'Mais opções da meta',
        editAction: 'Editar meta',
        convertAction: 'Transformar em caixinha',
        deleteAction: 'Excluir meta',
        completedBadge: 'Concluída',
        remainingLabel: 'Falta',
        predictionLabel: 'Previsão',
        avgPerMonthLabel: 'Média/mês',
        // months_zero: meta 100% atingida sem concluir gera previsão de 0 —
        // e a tela de hoje mostra "0 meses" (pt-BR trataria 0 como _one).
        months_zero: '{{count}} meses',
        months_one: '{{count}} mês',
        months_other: '{{count}} meses',
        deadlineLabel: 'Prazo',
        historyTitle: 'Histórico',
        seeLess: 'Ver menos',
        seeAll: 'Ver tudo',
        emptyTitle: 'Nenhum depósito ainda.',
        emptySubtitle: 'Comece a investir na sua meta!',
        depositedLabel: 'Depositado',
        depositDateWithNotes: '{{date}} · {{notes}}',
        reopenButton: 'Reabrir',
        completeButton: 'Concluir',
        depositButton: 'Depositar',
    },
    depositSheet: {
        title: 'Novo depósito',
        amountLabel: 'Valor',
        notesLabel: 'Observação (opcional)',
        notesPlaceholder: 'Ex: Salário de março',
        helper: 'O depósito só marca o progresso da meta — não mexe no saldo de nenhuma conta.',
        confirmButton: 'Confirmar depósito',
    },
    deleteDialog: {
        title: 'Excluir meta',
        message: 'Tem certeza? Os depósitos registrados na meta serão removidos. Nenhuma transação ou saldo de conta é alterado.',
        confirm: 'Excluir',
    },
    removeDepositDialog: {
        title: 'Remover depósito',
        message: 'Remover este depósito do histórico da meta? O progresso será ajustado. Nenhuma conta ou transação é afetada.',
        confirm: 'Remover',
    },
    form: {
        heroLabelCaixinha: 'Nome da caixinha',
        heroLabelMeta: 'Nome da meta',
        heroLabelNewCaixinha: 'Nova caixinha',
        heroLabelNewMeta: 'Nova meta',
        heroLabelConvert: 'Transformar em caixinha',
        namePlaceholder: 'Ex: Viagem, Reserva',
        accountLabelOptional: 'Conta (opcional)',
        accountLabel: 'Conta',
        accountFallback: 'Conta',
        accountLocked: '{{account}} — fixa (exclua e recrie pra trocar)',
        accountNone: 'Sem conta — vira meta',
        accountChoose: 'Escolher conta',
        targetLabelOptional: 'Valor-alvo (opcional)',
        targetLabel: 'Valor-alvo',
        initialLabel: 'Quanto já tem guardado (opcional)',
        initialSourceAccount: 'Já está no saldo',
        initialSourceApart: 'É um valor à parte',
        initialHelperNoAccount: 'Reserva parte do saldo da conta já na criação.',
        initialHelperAvailable: 'Disponível em {{account}}: {{amount}}.',
        initialHelperApart: 'Somo {{amount}} ao saldo de {{account}} e reservo. Seu disponível continua {{available}}.',
        initialHelperClamped: 'Só {{available}} cabem no saldo; reservo {{available}} e o resto você completa depois.',
        initialHelperClampedConvert: 'Só {{available}} cabem no saldo. Para trazer tudo, escolha “É um valor à parte” ou diminua o valor.',
        initialHelperFromBalance: 'Reservo do saldo de {{account}}: o disponível cai de {{from}} para {{to}}.',
        emergencyLabel: 'Reserva de emergência',
        guaranteedLabel: 'Limite garantido',
        guaranteedNone: 'Vincular a um cartão (opcional) — o valor guardado soma ao limite',
        guaranteedLinked: 'Soma ao limite disponível do cartão {{card}}',
        guaranteedClear: 'Remover vínculo com o cartão',
        guaranteedSelectorTitle: 'Cartão do limite garantido',
        emergencyDescription: 'Conta como colchão de segurança no score de saúde financeira.',
        deadlineLabel: 'Prazo (opcional)',
        colorLabel: 'Cor',
        iconLabel: 'Ícone',
        noteCaixinhaWithAccount: 'Reserva parte do saldo de {{account}}: o Disponível cai, mas o dinheiro continua na conta — não é transferência nem despesa.',
        noteCaixinha: 'Reserva parte do saldo: o Disponível cai, mas o dinheiro continua na conta — não é transferência nem despesa.',
        noteMeta: 'Meta é só acompanhamento: não reserva dinheiro nem mexe no saldo de nenhuma conta.',
        noteConvert: 'Escolha a conta onde o dinheiro está. O que a meta já tem vira o valor guardado, e a meta sai da lista.',
        convertedToast: 'A meta virou caixinha',
        convertShortfall: 'O Disponível só cobre {{available}}. Escolha “É um valor à parte” ou diminua o valor; a meta continua como está.',
        convertGoalMissing: 'Essa meta não existe mais.',
        saveA11yCreate: 'Criar',
        saveA11ySave: 'Salvar',
        accountSelectorClear: 'Sem conta (vira meta)',
        accountSelectorClearHint: 'Só acompanha o objetivo, sem separar dinheiro',
        accountSelectorTitle: 'Conta da caixinha',
        colorSheetTitle: 'Escolha uma cor',
        iconSheetTitle: 'Escolha um ícone',
        clampToast: {
            title: 'Guardei o que cabia',
            message: 'Reservei {{amount}} — o resto você completa na caixinha.',
        },
    },
};
